import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/district-actions';
import { DistrictActions } from '../constants';
import { IDistrict } from 'src/types/district';

export interface DistrictState {
    inProgress: boolean;
    authCode: string;
    error: string;
    data: Paginated<IDistrict>;
    current: IDistrict | null;
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
        inProgress: false,
    },
    current: null,
    currentFiles: null,
};

export function districts(state: DistrictState = initialState, action: Actions | any): DistrictState {
    switch (action.type) {
        case requestType(DistrictActions.PERSIST_DISTRICT):
            return { ...state, error: '', inProgress: true };
        case successType(DistrictActions.PERSIST_DISTRICT):
            return { ...state, inProgress: false };
        case failureType(DistrictActions.PERSIST_DISTRICT):
            return { ...state, inProgress: false };

        case requestType(DistrictActions.FETCH_DISTRICTS):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    page: 1,
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(DistrictActions.FETCH_DISTRICTS):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(DistrictActions.FETCH_DISTRICTS):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(DistrictActions.FETCH_DISTRICTS_SIMPLY):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    page: 1,
                    meta: state.data?.meta,
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(DistrictActions.FETCH_DISTRICTS_SIMPLY):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(DistrictActions.FETCH_DISTRICTS_SIMPLY):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(DistrictActions.FETCH_DISTRICT):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(DistrictActions.FETCH_DISTRICT):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(DistrictActions.FETCH_DISTRICT):
            return { ...state, inProgress: false, error: action.error };
        case requestType(DistrictActions.DELETE_DISTRICT):
            return { ...state, error: '', inProgress: true };
        case successType(DistrictActions.DELETE_DISTRICT):
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: IDistrict) => {
                        return user.id !== action.payload.id;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(DistrictActions.DELETE_DISTRICT):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };

        case successType(DistrictActions.UPDATE_DISTRICT):
            state.data.list.map((provider: IDistrict) => {
                if (provider.id !== action.payload.userId) {
                    return {
                        ...provider,
                        ...action.payload,
                    };
                }
                return provider;
            });
            return {
                ...state,
                data: {
                    ...state.data,
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(DistrictActions.UPDATE_DISTRICT):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };
        case requestType(DistrictActions.FETCH_FILES_DISTRICT):
            return { ...state, error: '', inProgress: true };
        case successType(DistrictActions.FETCH_FILES_DISTRICT):
            return { ...state, inProgress: false, currentFiles: action.payload };
        case failureType(DistrictActions.FETCH_FILES_DISTRICT):
            return { ...state, inProgress: false, error: action.error };
        case requestType(DistrictActions.DELETE_FILE_DISTRICT):
            return { ...state, error: '', inProgress: true };
        case successType(DistrictActions.DELETE_FILE_DISTRICT):
            const { sagaPayload } = action;
            const curNewFiles = (state.currentFiles ?? []).filter((file: any) => file.id !== sagaPayload.id);

            return {
                ...state,
                inProgress: false,
                currentFiles: curNewFiles,
            };
        case failureType(DistrictActions.DELETE_FILE_DISTRICT):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };

        case successType(DistrictActions.CREATE_FILES_DISTRICT):
            const curFiles = [...(state.currentFiles ?? [])];
            curFiles.push(action.payload);

            return {
                ...state,
                inProgress: false,
                currentFiles: curFiles,
            };
        case requestType(DistrictActions.CREATE_FILES_DISTRICT):
            return { ...state, error: '', inProgress: true };
        case failureType(DistrictActions.CREATE_FILES_DISTRICT):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };

        default:
            return state;
    }
}
